import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FC, useState } from 'react';

import { AdditionalSettingsModalType } from './types';
import AdditionalSettings from '.';
import { Fade } from '@mui/material';

const AdditionalSettingsModal: FC<AdditionalSettingsModalType> = (props) => {
    const [isExpended, setIsExpended] = useState<boolean>(false);
    return (
        <div>
            <Modal
                open={props.isOpen}
                onClose={props.onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Fade timeout={300} in={props.isOpen} exit={false}>
                    <Box>
                        <Box
                            className={`additional-settings-modal ${
                                isExpended ? 'expanded-modal' : ''
                            }`}
                        >
                            <AdditionalSettings
                                onCloseModal={props.onClose}
                                onGenerate={props.onGenerate}
                                parameters={props.parameters}
                                setIsExpended={setIsExpended}
                                country={props.country}
                            />
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default AdditionalSettingsModal;
